export default __webpack_public_path__ + "static/livret-fsc-7cbc9cc8e4fe68340f4684714251c82b.png";